export default {
    // 公司
    COMPANY: 0,
    // 部门
    DEPT: 1,
    // 员工
    STAFF: 2,
    // loading
    loadingTimeout: 300
}
